export const TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA = {
  EMPREGADOS: 'employees',
  LOCAIS_DE_TRABALHO: 'companies',
  EMPREGADORES: 'employers'
}

export const CAMPOS_DA_CONFIG_POR_TIPO_DE_FILTRO = {
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADOS]: 'empregados',
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.LOCAIS_DE_TRABALHO]: 'locaisDeTrabalho',
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADORES]: 'empregadores'
}

// Enum `entidade` esperado pelo backend na criação em massa (Selecao)
export const ENTIDADE_PARA_BACKEND = {
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADOS]: 'Empregado',
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.LOCAIS_DE_TRABALHO]: 'LocalDeTrabalho',
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADORES]: 'Empregador'
}

export const COMUNS_POR_TIPO_DE_FILTRO_DA_ESCALA_TEMPORARIA = {
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADOS]: 'employees/onlyNotFired',
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.LOCAIS_DE_TRABALHO]: 'companies/apenasAtivosEVisiveis',
  [TIPOS_DE_FILTRO_DA_ESCALA_TEMPORARIA.EMPREGADORES]: 'employers/apenasVisiveis'
}

export const ORIGENS_DA_SELECAO_DA_ESCALA_TEMPORARIA = {
  LISTA: 'lista',
  PLANILHA: 'planilha'
}

export const TIPO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS = 'escala_temporaria'
export const BUCKET_IMPORTADOR_DE_ESCALAS_TEMPORARIAS = 'arquivos'
export const TIPO_DE_ARQUIVO_DO_IMPORTADOR = 'importacao'
export const NOME_DA_ABA_CSV_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS = 'Escala Temporaria'
export const EXTENSOES_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS = ['xlsx', 'xls', 'csv']
// Um botão de download por formato, na mesma ordem do importador I05.
export const FORMATOS_DO_MODELO_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS = ['csv', 'xls', 'xlsx']
export const TIPOS_MIME_DO_IMPORTADOR_DE_ESCALAS_TEMPORARIAS = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
  'application/csv',
  'application/octet-stream',
  ''
]

export const ABAS_DA_ESCALA_TEMPORARIA = {
  ESCALA: 'escala',
  CALENDARIO: 'calendario'
}

// actions do resource `escalaTemporaria` (services.js -> escala-temporaria{/id}{/action})
// Obs.: criação em massa migrou para o app FastAPI (resource `escalaTemporariaCriacaoEmMassa`).
export const ACAO_HISTORICO = 'historico' // histórico de escalas temporárias
export const ACAO_CANCELAR = 'cancelar' // cancelar escala temporária

// A criação em massa gera um relatório do framework (GerarRelatorio); o acompanhamento
// é feito pela "nova fila de relatórios" que o sininho já consulta (sem polling celery).
